export const headingId = (id: string) => `${id}-heading`;

export const focusHeading = (id: string, options?: FocusOptions) =>
  document.getElementById(headingId(id))?.focus(options);

export const navigateToSection = (hash: string) => {
  const sectionId = hash.slice(1);

  document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  focusHeading(sectionId, { preventScroll: true });

  window.history.replaceState(null, '', hash);
};

export const openReference = (reference: string) => {
  if (reference.startsWith('#')) {
    navigateToSection(reference);
    return;
  }
  window.open(reference, '_blank', 'noopener,noreferrer');
};
